import { useCallback, useEffect, useState } from "react";

import { PublicService } from "@/services";

export const useMediaItem = (propertyId: string, mediaId: string) => {
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [isLoading, setLoading] = useState(true);

  const fetchData = useCallback(async (propertyId: string, mediaId: string) => {
    try {
      setLoading(true);
      const response = await PublicService.getMediaItem(Number(propertyId), Number(mediaId));

      if (response.status === "failed") {
        throw new Error("Failed to fetch public media item");
      }

      const result = response.resp;

      setData(result);
    } catch (err: unknown) {
      console.error(err);
      throw new Error(err as string);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(propertyId, mediaId).catch((err: unknown) => err);
  }, []);

  return { isLoading, setLoading, data };
};
